import { AxiosError, type AxiosRequestConfig } from 'axios';
import axiosInstance from 'Config/axios/axios-config';
import type { FetchResponseI } from 'types';

interface FetchDataOptions extends AxiosRequestConfig {
  /**
   * Si es true, incluye los campos meta y jsonapi de la respuesta JSON:API
   */
  includeJsonApiMeta?: boolean;
}

export async function fetchData<T>(url: string, options: FetchDataOptions = {}): Promise<FetchResponseI<T>> {
  const { includeJsonApiMeta, ...axiosOptions } = options;

  try {
    const response = await axiosInstance({
      url,
      ...axiosOptions,
      headers: {
        ...axiosOptions.headers,
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (axiosOptions.responseType === 'blob') {
      return {
        data: response.data,
        error: null,
      };
    }

    // Para respuestas normales, mantenemos la estructura data.data
    const result: FetchResponseI<T> = {
      data: response.data?.data,
      error: null,
    };

    // Opcionalmente incluir meta y jsonapi de JSON:API
    if (includeJsonApiMeta) {
      result.meta = response.data?.meta ?? null;
      result.jsonapi = response.data?.jsonapi ?? null;
    }

    return result;
  } catch (error) {
    const response: FetchResponseI<null> = {
      data: null,
      error: 'Ocurrio un problema, intentalo nuevamente',
    };

    if (error instanceof AxiosError) {
      response.error = error.response?.data?.error;
    } else if (error instanceof Error) {
      response.error = error.message;
    }

    return response;
  }
}
